import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import DatePicker from 'react-datepicker';
import ReactModal from 'react-modal';

export const ManifestDetailsUpdateModal = (props) => {
  const {
    isUpdateStatusModalOpen,
    updateStatus,
    isSubmittingUpdateStatus,
    fuelTypes,
    fireSizes,
    closeUpdateStatusModal,
    onImageError,
    submitUpdateStatus,
    handleUpdateStatusChange,
    backToEmailModal,
  } = props;

  return (
    <ReactModal
      isOpen={isUpdateStatusModalOpen}
      onClose={closeUpdateStatusModal}
      contentLabel='Update Manifest Status'
      className='update-manifest-status-modal'
      overlayClassName='update-manifest-status-overlay'
    >
      <div className='manifest-modal-wrapper'>
        <div className='manifest-modal-header'>
          <div className='header-text'>
            <h2 className='modal-title'>Update Manifest Status</h2>
          </div>
          <img
            alt='close'
            className='closeModal'
            onClick={closeUpdateStatusModal}
            src={require('../../assets/images/close_green.png').default}
            onError={onImageError}
          />
        </div>

        <div className='manifest-modal-body'>
          <form onSubmit={submitUpdateStatus}>
            <div className='form-group'>
              <label>Select Status *</label>
              <div className='select-wrapper disabled'>
                <div className='select-container'>
                  <select
                    className='form-control'
                    name='status'
                    value={updateStatus.status}
                    onChange={handleUpdateStatusChange}
                    required
                    disabled
                  >
                    <option value='Committed'>Committed</option>
                  </select>
                </div>
              </div>
            </div>

            <div className='form-group'>
              <label>Type of Assignment *</label>
              <div className='select-wrapper'>
                <div className='select-container'>
                  <select
                    className='form-control'
                    name='assignmentType'
                    value={updateStatus.assignmentType}
                    onChange={handleUpdateStatusChange}
                    required
                  >
                    <option value=''>Choose Type of Assignment</option>
                    <option value='1'>Wildfire</option>
                    <option value='2'>Rx Fire</option>
                    <option value='3'>Project</option>
                    <option value='4'>DCR</option>
                    <option value='5'>UI</option>
                    <option value='6'>OI</option>
                  </select>
                </div>
              </div>
            </div>

            <div className='form-group'>
              <label>Incident Name *</label>
              <input
                className='form-control'
                name='incidentName'
                value={updateStatus.incidentName}
                onChange={handleUpdateStatusChange}
                required
                disabled
              />
            </div>

            <div className='form-group'>
              <label>Location</label>
              <input
                className='form-control'
                name='location'
                value={updateStatus.location}
                onChange={handleUpdateStatusChange}
              />
            </div>

            <div className='form-group'>
              <label>Complexity</label>
              <div className='select-wrapper'>
                <div className='select-container'>
                  <select
                    className='form-control'
                    name='complexity'
                    value={updateStatus.complexity}
                    onChange={handleUpdateStatusChange}
                  >
                    <option value=''>Choose Complexity Level</option>
                    <option value='1'>1</option>
                    <option value='2'>2</option>
                    <option value='3'>3</option>
                    <option value='4'>4</option>
                    <option value='5'>5</option>
                  </select>
                </div>
              </div>
            </div>

            <div className='form-group'>
              <label>Fuel Type</label>
              <select
                className='form-control'
                name='fuelType'
                value={updateStatus.fuelType}
                onChange={handleUpdateStatusChange}
              >
                <option value=''>Choose Fuel Type</option>
                {fuelTypes?.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.value}- {item.label}
                  </option>
                ))}
              </select>
            </div>

            <div className='form-group'>
              <label>Fire Size</label>
              <select
                className='form-control'
                name='fireSize'
                value={updateStatus.fireSize}
                onChange={handleUpdateStatusChange}
              >
                <option value=''>Choose Fire Size</option>
                {fireSizes?.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.value}- {item.label}
                  </option>
                ))}
              </select>
            </div>

            <div className='form-group'>
              <label>Date On *</label>
              <DatePicker
                className='form-control'
                name='dateOn'
                selected={moment(updateStatus.dateOn || undefined)}
                onChange={(date) => {
                  handleUpdateStatusChange({
                    target: { name: 'dateOn', value: date },
                  });
                }}
                dateFormat='MM/DD/YYYY'
                placeholderText='Choose a Date on'
                required
                title='Choose a Date on'
                showMonthDropdown
                showYearDropdown
                dropdownMode='select'
                onKeyDown={(e) => e.preventDefault()}
                minDate={moment()}
              />
            </div>

            <div className='form-group'>
              <label>Notes</label>
              <textarea
                className='form-control'
                name='notes'
                value={updateStatus.notes}
                onChange={handleUpdateStatusChange}
                rows='4'
              />
            </div>

            <div className='resource_order_form_delete_modal_action'>
              <button
                type='button'
                className='button grey'
                onClick={backToEmailModal}
              >
                Back
              </button>
              <button
                type='submit'
                className='button'
                disabled={isSubmittingUpdateStatus}
              >
                {isSubmittingUpdateStatus ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </ReactModal>
  );
};

ManifestDetailsUpdateModal.propTypes = {
  isUpdateStatusModalOpen: PropTypes.bool.isRequired,
  updateStatus: PropTypes.object.isRequired,
  isSubmittingUpdateStatus: PropTypes.bool.isRequired,
  fuelTypes: PropTypes.array.isRequired,
  fireSizes: PropTypes.array.isRequired,
  closeUpdateStatusModal: PropTypes.func.isRequired,
  onImageError: PropTypes.func.isRequired,
  submitUpdateStatus: PropTypes.func.isRequired,
  handleUpdateStatusChange: PropTypes.func.isRequired,
  backToEmailModal: PropTypes.func.isRequired,
};
